const equipmentInfo = {
  service: 'Serviço',
  companies: 'Empresas',
  place: 'Local',
};

export default equipmentInfo;
